var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcPackageBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#555597",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M11 6.269l-6-3.46M14 10.668V5.335c0-.234-.062-.464-.179-.666-.117-.203-.285-.37-.488-.488L8.667 1.515c-.203-.117-.433-.18-.667-.18-.234 0-.464.063-.667.18L2.667 4.18c-.203.117-.371.285-.488.488C2.062 4.87 2 5.1 2 5.335v5.333c0 .234.062.463.179.666.117.202.285.37.488.487l4.666 2.667c.203.117.433.178.667.178.234 0 .464-.061.667-.178l4.666-2.667c.203-.117.371-.285.488-.487.117-.203.179-.432.179-.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#555597",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M2.18 4.64L8 8.008l5.82-3.366M8 14.72V8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPackageBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_package_blue.7a3ea88a.svg";
export { ForwardRef as ReactComponent };